import React from "react";
import { Route, Routes } from "react-router-dom";
import { TopSellingList } from "./containers";

export const TopSelling = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<TopSellingList />} />
      </Routes>
    </>
  );
};
